import { useEffect, useRef, useState } from "react";
import { Menu, X, CreditCard, Building2, TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../../constants/RouteData";
import MobileMenu from "../../../../components/mobileMenu/mobilemenu";

export default function NavBar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen]);

  const handleLinkClick = (path) => {
    setMobileMenuOpen(false);
    // You can handle navigation here with your routing solution
    window.location.href = `${path}`;
    console.log(`Navigate to: ${path}`);
  };

  return (
    <header className="w-full max-w-xs xs:px-4 sm:max-w-6xl mx-auto my-[20px] flex justify-between items-center py-4 z-50 relative">
      <img
        src="/assets/img/Footer logo.png"
        alt="Company Logo"
        height="24"
        width="142"
        className="cursor-pointer"
        onClick={() => {
          window.location.href = `${ROUTES.home}`;
        }}
      />

      {/* Hamburger Icon - Mobile Only */}
      <img
        src="/assets/img/menu.png"
        width="23px"
        height="16px"
        className="block sm:hidden cursor-pointer"
        onClick={toggleMenu}
        alt="Menu Icon"
      />

      {/* Desktop Nav */}
      <nav className="hidden sm:flex flex-row text-[16px] space-x-6 text-[#000000] font-medium">
        <button
          onClick={() => handleLinkClick("/personal-loan")}
          className="hover:text-green-500 cursor-pointer"
        >
          Personal Loan
        </button>
        <button
          onClick={() => handleLinkClick("/business-loan")}
          className="hover:text-green-500 cursor-pointer"
        >
          Business Loan
        </button>
        <button
          onClick={() => {
            window.open("https://payoff.club/", "_blank");
          }}
          className="hover:text-green-500 cursor-pointer"
        >
          PayOff
        </button>
      </nav>

      {/* Mobile Nav Overlay */}
      {isMobileMenuOpen && (
        <MobileMenu
          handleClose={() => {
            setMobileMenuOpen(false);
          }}
        />
      )}
    </header>
  );
}
